const focusVisible = '.focus-visible';

export default focusVisible;
